import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-modal-new-pdf',
  templateUrl: './modal-new-pdf.component.html'
})
export class ModalNewPdfComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  filename = '';
  ordner = '';
  schadennummer = '';
  schadenVorgangsnummer = '';
  Rechnungspruefung = '';

  taskList: any[] = [];
  uiTaskList: any[] = [];
  uiSelectTaskIndex = 0;
  selectedTask: any = null;

  uiSaveInCase = false;
  uiSaveInCaseDisabled = false;

  uiSelectDocumentTypeIndex = 0;
  dok_enmIdent_DokTyp = 1;
  nummerTyp = '';
  initialFilename = '';

  constructor(
    private popUpService: ExgModalService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeDocumentType();
    if (this.data) {
      if (this.data.taskList) {
        this.taskList = this.data.taskList;
        this.uiTaskList = this.taskList;

        if (this.uiTaskList.length === 0) {
          this.uiSaveInCase = true;
          this.uiSaveInCaseDisabled = true;
        }
      }
      if (this.data.originalDocData) {
        this.ordner = this.data.originalDocData.dokOrdner || '';

        if (this.data.originalDocData.dok_enmIdent_DokTyp) {
          this.dok_enmIdent_DokTyp = this.data.originalDocData.dok_enmIdent_DokTyp;
          this.uiSelectDocumentTypeIndex = this.enumSvc.getEnumerationList('DokTyp')
            .findIndex(e => e.enmIdent === this.dok_enmIdent_DokTyp);
        }
      }

      if (this.data.auftragData) {
        this.preFillData(this.data.auftragData);
      }
    }
  }

  isFilenameModified(): boolean {
    return this.filename !== this.initialFilename && this.filename.length > 0;
  }
  initializeDocumentType(): void {
    const dokTypList = this.enumSvc.getEnumerationList('DokTyp');
    const defaultIndex = dokTypList.findIndex(e => e.enmDefault);

    if (defaultIndex >= 0) {
      this.uiSelectDocumentTypeIndex = defaultIndex;
      this.dok_enmIdent_DokTyp = dokTypList[defaultIndex].enmIdent;
    } else if (dokTypList.length > 0) {
      this.uiSelectDocumentTypeIndex = 0;
      this.dok_enmIdent_DokTyp = dokTypList[0].enmIdent;
    }
  }

  preFillData(auftragData: any): void {
    if (auftragData) {
      if (auftragData.aueSchadenNr) {
        this.schadennummer = auftragData.aueSchadenNr;
      }

      if (auftragData.auNr) {
        this.schadenVorgangsnummer = auftragData.auNr;
      }

      let filenameSuffix = '';
      if (auftragData.aueSchadenNr) {
        filenameSuffix = auftragData.aueSchadenNr;
        this.nummerTyp = this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr');
      } else if (auftragData.auNr) {
        filenameSuffix = auftragData.auNr;
        this.nummerTyp = this.enumSvc.getFieldCaption('Auftrag', 'auNr');
      }

      if (filenameSuffix) {
        this.filename = '_' + filenameSuffix;
        this.initialFilename = this.filename;
      }
    }
  }

  setSelectedTask(index: number): void {
    this.uiSelectTaskIndex = index;

    if (this.uiTaskList && index >= 0 && index < this.uiTaskList.length) {
      this.selectedTask = this.uiTaskList[index];
    }
  }

  setDocumentType(index: number): void {
    this.uiSelectDocumentTypeIndex = index;
    const dokTypList = this.enumSvc.getEnumerationList('DokTyp');

    if (index >= 0 && index < dokTypList.length) {
      this.dok_enmIdent_DokTyp = dokTypList[index].enmIdent;
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.popUpService.close();
  }

  save(): void {
    if (this.isFilenameModified()) {
      const payload = {
        filename: this.filename,
        dok_enmIdent_DokTyp: this.dok_enmIdent_DokTyp,
        vorgID: this.selectedTask?.vorgID,
        uiSaveInCase: this.uiSaveInCase
      };

      this.popUpService.action(payload);
    }
  }
}
